/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Same_Maroon_Mongoose_LockInputs */

const fr_same_maroon_mongoose_lock = /** @type {(inputs: Same_Maroon_Mongoose_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviter`)
};

/**

* @param {Same_Maroon_Mongoose_LockInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const same_maroon_mongoose_lock = /** @type {((inputs?: Same_Maroon_Mongoose_LockInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Same_Maroon_Mongoose_LockInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_same_maroon_mongoose_lock(inputs)
});